module.exports = __webpack_public_path__ + "static/media/Klimaanlage.1de64405.png";